<template>
  <v-app id="inspire">
    <v-app-bar app flat color="white" height="auto" class="py-2">
      <v-container fluid>
        <v-row
          align="center"
          justify="space-between"
          class="flex-wrap"
        >
          <!-- LOGO Y SUBTÍTULO -->
          <v-col cols="12" sm="4" class="d-flex flex-column">
            <span class="text-h5 font-weight-bold">Soevii</span>
            <span class="text-caption grey--text">Dashboard de Huella de Carbono</span>
          </v-col>

          <!-- BOTONES ACCIONES -->
          <v-col
            cols="12"
            md="8"
            class="d-flex justify-end align-center flex-wrap gap-1"
          >
            <v-btn small outlined tile color="#6366F1" class="text-none mr-1">
              Sep 24
              <v-icon right size="18">mdi-calendar</v-icon>
            </v-btn>

            <v-btn small outlined tile color="#6366F1" class="text-none">
              <v-icon left size="18">mdi-file-pdf-box</v-icon>
              Descargar PDF
            </v-btn>

            <v-btn small outlined tile color="#6366F1" class="text-none ml-1">
              <v-icon left size="18">mdi-file-excel-box</v-icon>
              Exportar Excel
            </v-btn>
            <v-btn small text color="#6366F1" class="text-none" style="white-space: nowrap"  @click="analyticsDrawer = true">
              Abrir analíticas
              <v-icon right size="18">mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>



    <v-navigation-drawer v-model="drawer" app >
      <v-list>
        <v-list-item to="/uikits/fonts">
          <v-list-item-icon>
            <v-icon>mdi-format-paint</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Buttons 1</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/profileuikit">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Perfil</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/colors">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Colors</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/buttons">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Botón 2</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/dash">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dash</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/forms">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Forms</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/visual">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Visual</v-list-item-title>
        </v-list-item>
        <v-list-item to="/uikits/breadcrums">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Breadcrums</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Drawer derecho de analíticas -->
    <v-navigation-drawer
      v-model="analyticsDrawer"
      location="right"
      width="360"
      app
      temporary
      elevation="2"
      right
    >
      <!-- Header -->
      <v-container class="pb-0 pt-4 px-4">
        <div class="d-flex justify-space-between align-center">
          <div>
            <h3 class="text-h6 font-weight-bold mb-0">Reporting</h3>
            <h3 class="text-h6 font-weight-bold mt-n1">Analytics</h3>
          </div>
          <v-btn icon @click="analyticsDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-container>

      <v-divider class="my-2" />

      <!-- Contenido -->
      <v-container class="px-4 pb-10" style="overflow-y: auto">
        <!-- Resumen de objetivos -->
        <v-card outlined class="mb-4"  tile>
          <v-card-text>
            <!-- Encabezado -->
            <div class="d-flex justify-space-between align-center mb-2">
              <div class="text-h6 font-weight-bold">Resumen de objetivos</div>
              <v-icon size="16" color="#9CA3AF">mdi-help-circle-outline</v-icon>
            </div>

            <p class="text-body-2" style="color: #9CA3AF;">Para el período actual</p>

            <!-- Scope 1 y 2 -->
            <div class="d-flex justify-space-between align-center mt-4">
              <div class="text-body-1 font-weight-bold">Scope 1 & 2</div>
              <div class="text-body-2 font-weight-medium" style="color: #10B981;">
                Meta mensual alcanzada
              </div>
            </div>

            <!-- Scope 3 -->
            <div class="d-flex justify-space-between align-center mt-3">
              <div class="text-body-1 font-weight-bold">Scope 3</div>
              <v-btn
                tile
                outlined
                small
                color="#6366F1"
                class="text-none"
                style="text-transform: none; font-weight: 500;"
              >
                Seguimiento absoluto
              </v-btn>
            </div>
          </v-card-text>
        </v-card>


        <!-- Informar de los progresos -->
        <v-card outlined class="mb-4" tile>
          <v-card-text>
            <div class="d-flex justify-space-between align-center mb-4">
              <div class="text-h6 font-weight-bold">Informar de los progresos</div>
              <v-icon size="16" color="grey">mdi-help-circle-outline</v-icon>
            </div>

            <div class="d-flex justify-center">
              <v-progress-circular
                :value="30"
                size="110"
                width="8"
                color="green"
              >
                <div class="text-center">
                  <div class="text-h6 font-weight-bold">30%</div>
                  <div class="text-caption">Completado</div>
                </div>
              </v-progress-circular>
            </div>

            <p class="text-caption text-center mt-2">70% pendiente</p>
          </v-card-text>
        </v-card>

        <!-- Plan de acción -->
        <v-card outlined class="mb-4" tile>
          <v-card-text>
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="text-subtitle-2 font-weight-bold">Plan de acción para el clima</div>
              <v-icon size="16" color="grey">mdi-help-circle-outline</v-icon>
            </div>

            <div class="mb-2 d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2">Proyectos desplegados</span>
              </div>
              <strong>8</strong>
            </div>

            <div class="mb-2 d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2">Proyectos en curso</span>
              </div>
              <strong>5</strong>
            </div>

            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2">En tramitación</span>
              </div>
              <strong>12</strong>
            </div>
          </v-card-text>
        </v-card>


        <!-- KPIs -->
        <v-card outlined class="mb-4" tile>
          <v-card-text>
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="text-subtitle-2 font-weight-bold">Key environmental KPIs</div>
              <v-icon size="16" color="grey">mdi-help-circle-outline</v-icon>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2">tCO₂e reduced</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1">940</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success">15%</span>
              </div>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2">MWh saved</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1">2,180</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success">22%</span>
              </div>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2">m³ water saved</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1">15,400</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success">8%</span>
              </div>
            </div>

            <div class="d-flex justify-space-between align-center">
              <span class="text-body-2">tons recycled</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1">340</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success">45%</span>
              </div>
            </div>
          </v-card-text>
        </v-card>


        <v-card outlined class="mb-4 rounded-lg">
  <v-card-text>
    <!-- Encabezado -->
    <div class="d-flex justify-space-between align-center mb-4">
      <div class="d-flex align-center">
        <v-icon color="orange" size="18" class="mr-2">mdi-bell-outline</v-icon>
        <span class="text-subtitle-2 font-weight-bold">Analogies</span>
      </div>
      <v-icon size="16" color="grey">mdi-help-circle-outline</v-icon>
    </div>

    <!-- Cuerpo -->
    <div class="mb-2">
      <span>Equivalent to planting </span>
      <span class="font-weight-bold text-green">42,850</span>
      <span> trees</span>
    </div>

    <div>
      <span>Equivalent to recycling </span>
      <span class="font-weight-bold text-green">126</span>
      <span> tons</span>
    </div>
  </v-card-text>
</v-card>


      </v-container>
    </v-navigation-drawer>




    <v-main style="background-color: #F9FAFB;">
      <RouterView/>
    </v-main>
  </v-app>
</template>

<script>
import { RouterView } from 'vue-router';

export default {
  data: () => ({
    drawer: null,
    analyticsDrawer: false
   
  }),
  methods: {
    
  }
}
</script>
<style scoped>
.text-success {
  color: #16a34a;
}
.v-list-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>


